export function prizmIsEdge(userAgent: string): boolean {
  return userAgent.toLowerCase().includes('edge');
}
